import { render, staticRenderFns } from "./ItemGridViewCompany.vue?vue&type=template&id=de4e2f98&scoped=true&"
import script from "./ItemGridViewCompany.vue?vue&type=script&lang=js&"
export * from "./ItemGridViewCompany.vue?vue&type=script&lang=js&"
import style0 from "./ItemGridViewCompany.vue?vue&type=style&index=0&id=de4e2f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4e2f98",
  null
  
)

export default component.exports